import { CardsGridDragAndDrop } from '../GridDragAndDropDndKit/CardsGridDragAndDrop';
import { TableDragAndDrop } from '../TableDragAndDrop';

export const TableGridSwitchDragAndDrop = {
  grid: CardsGridDragAndDrop,
  table: TableDragAndDrop,
};
